import { TTypeOfCodec, TTypeOfNewDefault } from "../../../shared/src/codecs/codec";
import { required } from "../../../shared/src/codecs/types/required";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { form } from "../../../shared/src/codecs/types/form";
import { EmptyObject } from "../EmptyObject";

export const UnsendListingFromAuctionForm = form(
    required({
        listing_id: uuid(),
    }),
    EmptyObject,
);

export type TUnsendListingFromAuctionFormCodec = typeof UnsendListingFromAuctionForm;
export type TUnsendListingFromAuctionForm = TTypeOfCodec<TUnsendListingFromAuctionFormCodec>;
export type TUnsendListingFromAuctionFormNewDefault = TTypeOfNewDefault<TUnsendListingFromAuctionFormCodec>;
